// extracted by mini-css-extract-plugin
export var button = "_47-4";
export var hasDarkBackground = "_47-7";
export var hasLightBackground = "_47-6";
export var iconWrapper = "_47-0";
export var large = "_47-2";
export var medium = "_47-1";
export var small = "_47-5";
export var xsmall = "_47-3";